import React from 'react';
import config from "../config";
import WhatsAppLogo from "../assets/images/WhatsAppLogo.png";
import MessengerLogo from "../assets/images/MessengerLogo.png";
import TelegramLogo from "../assets/images/TelegramLogo.png";
import WebexLogo from "../assets/images/Webex.png";
import InstagramLogo from "../assets/images/InstagramLogo.png";
import MobileUser from "../assets/images/mobile-webchat.png";
import Profile from "../assets/images/chat.png";

const PlatformIcon = ({conversation, size, platform}) => {

    if (platform) {
        conversation = {platform: platform}
    }

    return (
        <div>
            {conversation.platform === config.platformsMap.whatsapp &&
                <div>
                    <img src={WhatsAppLogo} alt="edit" width={size} height={size}/>
                </div>}
            {conversation.platform === config.platformsMap.messenger &&
                <div>
                    <img src={MessengerLogo} alt="edit" width={size} height={size}/>
                </div>}
            {conversation.platform === config.platformsMap.telegram &&
                <div>
                    <img src={TelegramLogo} alt="edit" width={size} height={size}/>
                </div>}
            {conversation.platform === config.platformsMap.webex &&
                <div>
                    <img src={WebexLogo} alt="edit" width={size} height={size}/>
                </div>}
            {conversation.platform === config.platformsMap.instagram &&
                <div>
                    <img src={InstagramLogo} alt="edit" width={size} height={size}/>
                </div>}
            {(conversation.platform === config.platformsMap.webchat) &&
                <div>
                    {conversation.fromMobile && (
                        <div>
                            <img src={MobileUser} alt="edit" width={size}
                                 height={size}/>
                        </div>
                    )}
                    {!conversation.fromMobile && (
                        <div>
                            <img src={Profile} alt="edit" width={size}
                                 height={size}/>
                        </div>
                    )}
                </div>
            }
        </div>
    );
};

export default PlatformIcon;


// WEBPACK FOOTER //
// ./src/components-new/PlatformIcon.jsx